import { WidgetsCategoriesMain } from '@/widgets/categories';

export const PagesCategoriesMain = () => <WidgetsCategoriesMain />;
